// Included in here so theming doesn't have to depend on utils

export const pxToRem = (size: number) => `${size / 16}rem`

export const pxToEm = (size: number) => `${size / 16}em`
